import React, { useEffect } from 'react'
import Box from '@mui/material/Box';
import FilledInput from '@mui/material/FilledInput';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Button, MenuItem, TextField } from '@mui/material';
import Textarea from '@mui/joy/Textarea';
import FormLabel from '@mui/joy/FormLabel';
import { isEmpty } from 'lodash';
import './index.css'
import { useSendEnquiryMutation } from 'config/api/waV1_user';
import { useDispatch, useSelector } from 'react-redux';
import { toggleError, toggleNoti } from 'config/slice/message';
import { KEY_ERROR_SUG_NOT_FILLED, KEY_ERROR_SUG_SENT_FAILED, KEY_LABEL_SUG_EMAIL, KEY_LABEL_SUG_ENQUIRY_TYPE, KEY_LABEL_SUG_MSG, KEY_LABEL_SUG_NAME, KEY_LABEL_SUG_PHONE, KEY_LABEL_SUG_SEND, KEY_NOTI_SUG_SENT_SUCC, MODULE_REPLY_SELECTION, MODULE_SUGGESTION } from 'config/const/locale';
import { useTranslation } from 'react-i18next';
import { sug_data } from 'config/dataToRender/suggestion';


const catogories = sug_data

const defData = {
    "name": "",
    "email": "",
    "phone": "",
    "content": "",
    "enquiry_type": ""
}

export default function Suggestion({
    type
}) {

    const { t } = useTranslation([MODULE_SUGGESTION, MODULE_REPLY_SELECTION])
    const [iptVal, setIptVal] = React.useState(defData)
    const [iptValErr, setIptValErr] = React.useState(defData)
    const [sendFn] = useSendEnquiryMutation()
    const dispacth = useDispatch()

    const saveIptVal = (type) => (e) => {
        if (!isEmpty(e.target.value)) {
            setIptVal(p => ({ ...p, [type]: e.target.value }))
            setIptValErr(p => ({ ...p, [type]: '' }))
            return
        }
        setIptVal(p => ({ ...p, [type]: '' }))
    }

    const handleSend = () => {
        const vals = Object.keys(iptVal).filter(i => isEmpty(iptVal[i]))
        if (!isEmpty(vals)) {
            vals.map(i => setIptValErr(p => ({ ...p, [i]: t(KEY_ERROR_SUG_NOT_FILLED) })))
            return
        }

        sendFn(iptVal)
            .then(res => {
                if (res.data?.data?.enquiry) {
                    setIptVal(defData)
                    dispacth(toggleNoti({
                        indicator: true,
                        msg: t(KEY_NOTI_SUG_SENT_SUCC)
                    }))
                } else {
                    dispacth(toggleError({
                        indicator: true,
                        msg: t(KEY_ERROR_SUG_SENT_FAILED)
                    }))
                }
            })
            .catch(reason => {
                dispacth(toggleError({
                    indicator: true,
                    msg: t(KEY_ERROR_SUG_SENT_FAILED)
                }))
            })
    }

    React.useEffect(() => {
        if (type) setIptVal(prev => ({ ...prev, "enquiry_type": type }))
    }, [type])

    return (
        <Box
            className='sug'
            component="form"
            sx={{
                width: '60%',
                m: '0 auto',
                '& > :not(style)': { m: 1 },
                '& *': {
                    fontSize: 14
                }
            }}
            noValidate
            autoComplete="off"
        >
            <FormControl fullWidth variant="standard">
                <TextField
                    select
                    label={t(KEY_LABEL_SUG_ENQUIRY_TYPE)}
                    variant='standard'
                    value={iptVal.enquiry_type}
                    error={!isEmpty(iptValErr.enquiry_type)}
                    helperText={iptValErr.enquiry_type}
                    onChange={saveIptVal('enquiry_type')}
                >
                    {catogories.map((option) => (
                        <MenuItem key={option.id} value={option.value}>
                            {t(option.label, { ns: MODULE_REPLY_SELECTION })}
                        </MenuItem>
                    ))}
                </TextField>
            </FormControl>

            <FormControl fullWidth variant="standard" error={!isEmpty(iptValErr.name)}>
                <InputLabel htmlFor="name">{t(KEY_LABEL_SUG_NAME)}</InputLabel>
                <Input
                    id="name"
                    aria-describedby="name"
                    value={iptVal.name}
                    onChange={saveIptVal('name')}
                />
                <FormHelperText id="name">{iptValErr.name}</FormHelperText>
            </FormControl>

            <FormControl fullWidth variant="standard" error={!isEmpty(iptValErr.email)}>
                <InputLabel htmlFor="email">{t(KEY_LABEL_SUG_EMAIL)}</InputLabel>
                <Input
                    id="email"
                    value={iptVal.email}
                    aria-describedby="email"
                    onChange={saveIptVal('email')}
                />
                <FormHelperText id="email">{iptValErr.email}</FormHelperText>
            </FormControl>

            <FormControl fullWidth variant="standard" error={!isEmpty(iptValErr.phone)}>
                <InputLabel htmlFor="phone">{t(KEY_LABEL_SUG_PHONE)}</InputLabel>
                <Input
                    id="phone"
                    value={iptVal.phone}
                    aria-describedby="phone"
                    onChange={saveIptVal('phone')}
                />
                <FormHelperText id="phone">{iptValErr.phone}</FormHelperText>
            </FormControl>

            <FormControl fullWidth variant="standard" error={!isEmpty(iptValErr.content)}>
                {/* <FormLabel htmlFor='content'>正文</FormLabel> */}
                <FormLabel htmlFor='content'>&nbsp;</FormLabel>
                <Textarea
                    id='content'
                    variant="outlined"
                    placeholder={t(KEY_LABEL_SUG_MSG)}
                    value={iptVal.content}
                    minRows={8}
                    sx={{ background: 'transparent' }}
                    error={!isEmpty(iptValErr.content)}
                    onChange={saveIptVal('content')}
                />
                <FormHelperText>{iptValErr.content}</FormHelperText>
            </FormControl>

            <Button variant='contained' onClick={handleSend}>{t(KEY_LABEL_SUG_SEND)}</Button>
        </Box>
    )
}
